/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const IncidentsProblemTypes = {
    IncidentNichtGefunden: 'IncidentNichtGefunden',
    IncidentFunkprotokollNichtGefunden: 'IncidentFunkprotokollNichtGefunden',
    IncidentFunkprotokollFallNichtGefunden: 'IncidentFunkprotokollFallNichtGefunden',
    IncidentVorlageNichtGefunden: 'IncidentVorlageNichtGefunden',
    IncidentVorlageGeloescht: 'IncidentVorlageGeloescht',
    IncidentBenutzerIstKeinManager: 'IncidentBenutzerIstKeinManager',
    IncidentBenutzerIstKeinManagerOderAbarbeiter: 'IncidentBenutzerIstKeinManagerOderAbarbeiter',
    IncidentBenutzerIstKeinManagerOderAbarbeiterOderErsteller: 'IncidentBenutzerIstKeinManagerOderAbarbeiterOderErsteller',
    IncidentBildKeinZugriff: 'IncidentBildKeinZugriff',
    IncidentKeinZugriff: 'IncidentKeinZugriff',
    IncidentKeinAbteilungZugriff: 'IncidentKeinAbteilungZugriff'
} as const;
export type IncidentsProblemTypes = typeof IncidentsProblemTypes[keyof typeof IncidentsProblemTypes];

